import { Component } from '@angular/core';

@Component({
  selector: 'app-catering-page',
  templateUrl: './catering-page.component.html',
  styleUrl: './catering-page.component.scss'
})

export class CateringPageComponent {

    downloadMenu(): void {
        const link = document.createElement('a');
        link.href = 'assets/menu/Kitchen Magic Menu - new timing.pdf';
        link.download = 'Kitchen Magic Menu.pdf';
        link.click();
    }

}
